const PLOT_WIDTH = 4750;
const PRINT_PLOT_WIDTH = 1450;
const STROKE_COLOR = '#000000';
const GRID_COLOR = '#FF0000';
const PRINT_ECG_DURATION = 10;

export { PLOT_WIDTH, STROKE_COLOR, GRID_COLOR, PRINT_ECG_DURATION, PRINT_PLOT_WIDTH };
